module.exports = __webpack_public_path__ + "img/tomato.7c56fbf9.svg";